module.exports = __webpack_public_path__ + "static/media/se-iPC.1c21278c.jpg";